import { Checkbox, Radio } from "@mui/material";
import type { ChangeEvent } from "react";
import { useState } from "react";

interface SingleBooleanInputProps {
  defaultValue: boolean | null;
  onInputChange?: (...values: unknown[]) => void;
  type?: string;
  disabled?: boolean;
}

const SingleBooleanInput = ({
  defaultValue,
  onInputChange,
  type,
  disabled,
}: SingleBooleanInputProps) => {
  const [value, setValue] = useState(defaultValue ?? false);
  const onChange = (
    _: ChangeEvent<HTMLInputElement>,
    checked: boolean
  ): void => {
    setValue(checked);
    if (onInputChange) {
      onInputChange(checked);
    }
  };

  if (type === "radio") {
    return <Radio checked={value} disabled={disabled ? !value : false} onChange={onChange} />;
  }
  return (
    <div className="flex w-full flex-row items-center justify-center">
      <Checkbox checked={value} disabled={disabled} onChange={onChange} />
    </div>
  );
};

export default SingleBooleanInput;
